// OpCo workspace URL helpers. The active workspace lives in the URL prefix
// /o/<code>/ so each browser tab can sit in a different OpCo; switching is a
// full page load. With the OpCo flag off every helper returns the "no
// workspace" answer, so the router basename is '' and no header is sent.
import { OPCO_FLAG } from './runtimeConfig'

export const ALL_OPCOS_CODE = '_all'

const PREFIX_RE = /^\/o\/([^/?#]+)(?:\/|$)/

export function isOpcoFlagOn() {
  return OPCO_FLAG === true
}

// '/o/nl01/requests/5' -> 'nl01'; anything else -> null.
export function parseWorkspaceCode(pathname) {
  if (typeof pathname !== 'string') return null
  const match = PREFIX_RE.exec(pathname)
  if (!match) return null
  try {
    return decodeURIComponent(match[1])
  } catch {
    return null
  }
}

// The workspace code of this page load, or null (flag off / no prefix).
export function getWorkspaceCode() {
  if (!isOpcoFlagOn() || typeof window === 'undefined') return null
  return parseWorkspaceCode(window.location.pathname)
}

// BrowserRouter basename: '/o/<code>' inside a workspace, otherwise ''.
export function getRouterBasename() {
  const code = getWorkspaceCode()
  return code ? `/o/${encodeURIComponent(code)}` : ''
}

// Absolute in-app path for a workspace: workspacePath('nl01') -> '/o/nl01/'.
export function workspacePath(code, path = '/') {
  const rest = path.startsWith('/') ? path : `/${path}`
  return `/o/${encodeURIComponent(code)}${rest}`
}

// An in-app path for a plain <a href> / window.open (which bypass the router's
// basename), kept in the current workspace: '/requests/5' -> '/o/nl01/requests/5'.
// Unchanged with the flag off, outside a workspace, for external / relative
// URLs and for paths already carrying a workspace prefix.
export function inWorkspace(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return path
  const code = getWorkspaceCode()
  if (!code || parseWorkspaceCode(path)) return path
  return workspacePath(code, path)
}

// Full-page navigation (a workspace switch reloads the app). An object so
// tests can replace the methods; jsdom cannot navigate.
export const workspaceNav = {
  assign: (url) => window.location.assign(url),
  replace: (url) => window.location.replace(url),
}
